export var FORMAT = 'format';
export var ACTION = 'action';
export var SHARE = 'share';
export var DOWNLOAD = 'download';
export var BLOCK_LINK = 'block_link';
export var DELETE = 'delete';
export var EXPAND = 'expand';
export var FULL_WIDTH_EXPAND = 'full_width_expand';
export var FULL_WIDTH_SHRINK = 'full_width_shrink';
export var EXPAND_TABLE = 'expand_table';
export var REDUCE_TABLE = 'reduce_table';
export var ENABLE_CODE_WRAPPING = 'enable_code_wrapping';
export var DISABLE_CODE_WRAPPING = 'disable_code_wrapping';
export default {
  FORMAT: FORMAT,
  ACTION: ACTION,
  SHARE: SHARE,
  BLOCK_LINK: BLOCK_LINK,
  DOWNLOAD: DOWNLOAD,
  DELETE: DELETE,
  EXPAND: EXPAND,
  EXPAND_TABLE: EXPAND_TABLE,
  REDUCE_TABLE: REDUCE_TABLE,
  FULL_WIDTH_EXPAND: FULL_WIDTH_EXPAND,
  FULL_WIDTH_SHRINK: FULL_WIDTH_SHRINK,
  ENABLE_CODE_WRAPPING: ENABLE_CODE_WRAPPING,
  DISABLE_CODE_WRAPPING: DISABLE_CODE_WRAPPING
};